import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { changeRegion, resetFilters } from "../redux/regionsSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import { ErrorList } from "./ErrorList";
import { Filters } from "./Filters";
import { useError } from "../hooks/useError";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export const Edit = ({
  isOpen,
  onClose,
  selectedRegion: { name, id, location_ids, isDefault },
  locations
}) => {
  const dispatch = useDispatch();

  const close = () => {
    dispatch(resetFilters());
    onClose();
  };

  const { errors, status } = useError(close);

  const [title, setTitle] = useState(name);
  const [dropdownError, setDropdownError] = useState("");

  const selected = locations.filter((location) => location_ids.includes(location.id));

  const [selectedLocations, setSelectedLocations] = useState(selected);

  const save = () => {
    dispatch(changeRegion({ id, name: title, locations: selectedLocations }));
  };

  const primaryButtonDisabled = !(title && title.trim() && status !== "pending");

  const onInputChange = (title) => {
    setTitle(title);
  };

  const onSelectChange = (data) => {
    if (!isDefault) {
      setSelectedLocations(data);
    } else if (location_ids.every((id) => data.some((location) => location.id == id))) {
      setSelectedLocations(data);
    } else {
      setDropdownError(
        "* In order to unassign location from default region, assign it to new region"
      );
    }
  };

  return (
    <>
      <MainModal
        parentSelector=".regions"
        isOpen={isOpen}
        onClose={close}
        headerText={
          <>
            Edit Region - <span className="text-bold">{name}</span>
          </>
        }
        headerCloseHandler={close}
        height="auto"
        width={900}
        primaryButtonText="Save"
        primaryBtnHandler={save}
        primaryButtonClass="primary"
        primaryButtonDisabled={primaryButtonDisabled}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        secondaryBtnClass="secondary"
        containerClassName="edit"
        isAdminPanel={false}
      >
        <Filters
          name={title}
          onInputChange={onInputChange}
          locations={locations}
          selectedLocations={selectedLocations}
          onSelectChange={onSelectChange}
          dropdownError={dropdownError}
        />
        {status === "pending" && <LoadingAnimation uiLoader />}
        <ErrorList errors={errors} />
      </MainModal>
    </>
  );
};
